<!-- @format -->
<template>
  <mq-layout :mq="['sm', 'md']">
    <div class="mobile-index" id="mobile-index">
      <img src="@/assets/images/mobile/top.jpg" alt="" />
    </div>
  </mq-layout>
</template>

<script>
export default {
  props: {
    kinostart: {
      type: String,
      default: 'Releaseline',
    },
    showKinofinder: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss">
.no-scroll {
  overflow: hidden;
  height: 100vh;
  scrollbar-width: 0;
  z-index: 0;
}
.fullScreen {
  height: 100vh;
  z-index: 0;
}
.mobile-index {
  z-index: -20;
  $self: &;
  position: relative;
  margin-top: 50px;
  img {
    width: 100%;
  }
}
</style>
